import { useEffect, useState } from 'react'
import { useParams } from "react-router";
import { getInvitados } from "../../fetch/invitados";

export default function Asist() {

    let params = useParams();
    const [Invitado, setInvitado] = useState([])

    useEffect(() => {
        if (params.hash) {
            getInvitados(params.hash).then(res => {
                //console.log(res)
                setInvitado(res)
            })
        }

    }, [params])

    return (

        <div>Bienvenido
            <table>
                <tbody>
                {
                    Invitado.map((el, ind) => (
                        <tr key={ind}>
                            <td>{el.NombreC}</td>
                        </tr>
                    ))
                }
                </tbody>
            </table>
        </div>
    )
}
